import * as types from '../mutations'
import axios from 'axios'

const state = {
    locale: process.env.DEFAULT_LOCALE,
    locales: [],
    roles: [],
    config: [],
    locationTypes: [],
    post_tags: [],
    posts: [],
}

const mutations = {

    [types.GENERAL_LOCALE_SET] (state, { locale })
    {
        this._vm.$i18n.set(locale)
        state.locale = locale
    },

    [types.GENERAL_LOCALE_RESET] (state)
    {
        state.locale = process.env.DEFAULT_LOCALE
        this._vm.$i18n.set(state.locale)
    },

    [types.GENERAL_UPDATE_TABLE_DATA] (state, { table, data})
    {
        // Hack ... ( https://github.com/matfish2/vue-tables-2/issues/407 )
        this.state[table].data = data
        const oldFilter = this.state[table].query
        this.commit(`${table}/SET_FILTER`, '---')
        this.commit(`${table}/SET_FILTER`, oldFilter)
    },

    [types.GENERAL_FETCH_SETTINGS] (state, settings)
    {
        state.locales = settings.locales
        state.roles = settings.roles
        state.config = settings.config
        state.locationTypes = settings.location_types
        state.post_tags = settings.post_tags
    },

    [types.GENERAL_FETCH_POSTS] (state, posts)
    {
        state.posts = posts
    },

}

const actions = {

    init({dispatch})
    {
        try {
          dispatch('localeReset')
        } catch(e) {
          console.log('Error in general init localeReset', e)
        }
        try  {
          dispatch('fetchSettings')
        } catch(e) {
          console.log('Error in general init fetchSettings', e)
        }
        // count: Vue.i18n.translate('TABLE.COUNT')
    },

    localeSet({commit}, locale)
    {
        commit(types.GENERAL_LOCALE_SET, { locale: locale })
    },

    localeReset({commit})
    {
        let locale = navigator.language || navigator.userLanguage
        if (!this._vm.$i18n.localeExists(locale))
        {
            locale = document.documentElement.lang ? document.documentElement.lang : process.env.DEFAULT_LOCALE
        }
        commit(types.GENERAL_LOCALE_SET, { locale: locale })
    },

    fetchSettings({commit})
    {
        return new Promise(async(resolve, reject) => {
            try {
                const data = await axios.get(process.env.API_URL + '/v1/data')
                commit(types.GENERAL_FETCH_SETTINGS, data.data)
                resolve(data.data)
            } catch(e) {
                reject()
            }
        })
    },

    fetchPosts({commit})
    {
        return new Promise(async(resolve, reject) => {
            try {
                const data = await axios.get(`${process.env.API_URL}/v1/admin/posts`, { params: { type: 'site', simple: true }}).then(res => res.data)
                if (data && data.data) {
                    commit(types.GENERAL_FETCH_POSTS, data.data)
                    resolve(data.data.data)
                } else {
                    reject()
                }
            } catch(e) {
                reject()
            }
        })
    }

}

const getters = {
    generalLocales: state => state.locales,
    generalRoles: state => state.roles,
    generalConfig: state => JSON.parse(JSON.stringify(state.config)),
    generalCurrentLocale: state => state.locale,
    generalLocationTypes: state => state.locationTypes,
    generalPosts: state => state.posts,
    generalPages: state => state.posts.map(post => post.slug),
}

export default {
    mutations,
    actions,
    getters,
    state
}



// WEBPACK FOOTER //
// ./src/store/modules/general.js